import { BrandColors } from "../../dist";
var storybookStyles = {
  main: {
    backgroundColor: "white",
    margin: 15,
    maxWidth: 800
  },
  storyGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr 1fr",
    gridTemplateRows: "1fr 1fr 1fr",
    gridGap: "10px"
  },
  storyGridItem: {
    gridRow: 2,
    gridColumn: 2,
    alignSelf: "center",
    justifyContent: "center"
  },
  invertedLogo: {
    backgroundColor: BrandColors.primary.hex,
    margin: 20,
    padding: 20
  },
  logo: {
    paddingLeft: 20
  },
  solidColorSample: {
    display: "flex"
  },
  colorBlock: {
    height: 125,
    width: 300,
    marginLeft: 0,
    marginTop: 10,
    marginRight: 20,
    marginBottom: 10
  }
};
export default storybookStyles;